import React from 'react'
import { Accordion, Box, Stack, Text, Checkbox, StackSeparator } from '@chakra-ui/react'

// value: Accordion.Itemの識別子。未指定時はtitleをフォールバック値として使用
export const SearchFilterItem = ({ title, options, selectedItems, onChange, disabled = false, value = title }) => {
  return (
    <Accordion.Item border="none" disabled={disabled} value={value}>
      <Accordion.ItemTrigger px={2} py={4} fontSize="sm" gap={2} _hover={{ bg: 'inherit' }}>
        <Stack w="100%" textAlign="left">
          <Box flex="1" fontWeight="semibold">
            {title}
          </Box>
          {selectedItems.length > 0 && (
            <Text fontSize="3xs" color="label.link">
              {selectedItems.map((v) => options.find((opt) => opt.value === v)?.label || v).join('、')}
            </Text>
          )}
        </Stack>
        <Accordion.ItemContext>
          {({ expanded }) =>
            expanded && (
              <Text
                as="span"
                fontSize="2xs"
                flexShrink={0}
                color={selectedItems.length > 0 ? 'label.link' : 'label.tertiary'}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  onChange([])
                }}
              >
                クリア
              </Text>
            )
          }
        </Accordion.ItemContext>
        <Accordion.ItemIndicator />
      </Accordion.ItemTrigger>
      <Accordion.ItemContent>
        <Accordion.ItemBody bgColor="bg.secondary" p={0}>
          <Stack gap={0} separator={<StackSeparator />}>
            {options.map(({ label, value }) => (
              <Checkbox.Root
                key={value}
                value={value}
                size="sm"
                colorPalette="blue"
                px={2}
                py={4}
                checked={selectedItems.includes(value)}
                onCheckedChange={() => {
                  if (selectedItems.includes(value)) {
                    onChange(selectedItems.filter((item) => item !== value))
                  } else {
                    onChange([...selectedItems, value])
                  }
                }}
              >
                <Checkbox.HiddenInput />
                <Checkbox.Control borderWidth="2px" borderColor="divider.dark" _checked={{ borderColor: 'colorPalette.solid' }}>
                  <Checkbox.Indicator />
                </Checkbox.Control>
                <Checkbox.Label>
                  <Text fontSize="xs">{label}</Text>
                </Checkbox.Label>
              </Checkbox.Root>
            ))}
          </Stack>
        </Accordion.ItemBody>
      </Accordion.ItemContent>
    </Accordion.Item>
  )
}
